module.exports = __webpack_public_path__ + "static/media/product_01.be462ae4.jpg";